import { useState, useEffect } from "react";
import { Button, Box, TextField, Typography } from "@mui/material";
import { UseArticleGroups } from "./UseArticleGroups";
import { useNavigate, useLocation } from "react-router-dom";
import ProgressCom from "../../components/ProgressCom";
import Detail from "../../main/detail/Detail";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import Editor from "ckeditor5-custom-build/build/ckeditor";
import { rsProgress, rsActiveMenu, rsGotoLast } from "../../RecoilStates";
import { useRecoilState } from "recoil";
import ArticleAdvsGrid from "./ArticleAdvsGrid";
import useBreakpoints from "../../hooks/useBreakpoints";

export default function EditWriEditArticleGroupster() {
  const [msGotoLast, setMsGotoLast] = useRecoilState(rsGotoLast);
  const [msActiveMenu, setMsActiveMenu] = useRecoilState(rsActiveMenu);
  const [progress, setProgress] = useRecoilState(rsProgress);
  const navigate = useNavigate();
  const location = useLocation();
  const [brand, setBrand] = useState();
  const { isSmall } = useBreakpoints();

  const { GetArticleGroupByID, validate, UpdateArticleGroup } =
    UseArticleGroups();
  const [state, setState] = useState({
    id: undefined,
    faName: undefined,
    enName: undefined,
    description: undefined,
  });

  useEffect(() => {
    if (location.state) {
      GetArticleGroupByID(location.state.id, (callback) => {
        setState({
          id: callback.id,
          faName: callback.faName,
          enName: callback.enName,
          description: callback.description,
        });
      });
    }
  }, [location.state]);

  const [errorState, setErrorState] = useState({
    faName: false,
    enName: false,
  });

  return (
    <Detail
      breadChilds={{
        title: "مدیریت محتوا",
        childs: [
          { name: msActiveMenu.pageTitle, url: "/articlegroups" },
          {
            name: "ویرایش گروه مقاله",
            url: "/articlegroups/editArticleGroup",
          },
        ],
      }}
    >
      {!brand ? (
        <Box display="grid" gridTemplateColumns="repeat(12, 1fr)" gap={3}>
          <Box gridColumn={isSmall ? "span 12" : "span 4"}>
            <TextField
              fullWidth
              value={state.faName ? state.faName : ""}
              error={errorState.faName}
              label="نام فارسی"
              size="small"
              variant="outlined"
              onChange={(evt) => {
                setState({ ...state, faName: evt.target.value });
              }}
              InputLabelProps={{
                shrink: true,
              }}
            />
          </Box>
          {!isSmall && <Box gridColumn="span 8"></Box>}
          <Box gridColumn={isSmall ? "span 12" : "span 4"}>
            <TextField
              fullWidth
              value={state.enName ? state.enName : ""}
              error={errorState.enName}
              label="نام لاتین"
              sx={{
                input: { direction: "rtl" },
              }}
              size="small"
              variant="outlined"
              onChange={(evt) => {
                setState({ ...state, enName: evt.target.value });
              }}
              InputLabelProps={{
                shrink: true,
              }}
            />
          </Box>
          {!isSmall && <Box gridColumn="span 8"></Box>}
          <Box gridColumn="span 12" gridRow={isSmall ? "span 12" : "span  2"}>
            <Typography sx={{ mb: 1 }} color="secondary" variant="subtitle1">
              توضیحات :{" "}
            </Typography>
            <Box className="fullCk">
              {state.id !== "" && (
                <CKEditor
                  config={{
                    language: "fa",
                    link: {
                      decorators: {
                        addTargetToExternalLinks: {
                          mode: "automatic",
                          callback: (url) => /^(https?:)?\/\//.test(url),
                          attributes: {
                            target: "_blank",
                            rel: "noopener noreferrer",
                          },
                        },
                      },
                    },
                  }}
                  editor={Editor}
                  data={state.description ? state.description : ""}
                  onChange={(event, editor) => {
                    const data = editor.getData();
                    if (state.id) {
                      setState({ ...state, description: data });
                    }
                  }}
                  onReady={(editor) => {
                    editor.editing.view.change((writer) => {
                      writer.setStyle(
                        "height",
                        "300px",
                        editor.editing.view.document.getRoot()
                      );
                    });
                  }}
                />
              )}
            </Box>
          </Box>
          <Box id="ArticleAdv" gridColumn="span 12">
            <Typography color="secondary" sx={{ mb: 1 }} variant="subtitle1">
              تبلیغات گروه مقاله :{" "}
            </Typography>
            <ArticleAdvsGrid groupID={state.id && state.id} />
          </Box>
          <Box
            gridColumn="span 12"
            sx={{ display: "flex", justifyContent: "center", mt: 3 }}
          >
            <Button
              sx={{ mr: 2, width: "100px" }}
              variant="contained"
              color="secondary"
              onClick={() => {
                if (validate(state, setErrorState) == 200) {
                  setProgress(true);
                  UpdateArticleGroup(state, () => {
                    setMsGotoLast(true);
                    navigate("/articlegroups", {
                      state: { ...location.state, isBack: true },
                      replace: true,
                    });
                  });
                }
              }}
            >
              ثبت
            </Button>
            <Button
              sx={{ width: "100px" }}
              variant="outlined"
              color="secondary"
              onClick={() => {
                navigate("/articlegroups", {
                  state: { ...location.state, isBack: true },
                  replace: true,
                });
              }}
            >
              بازگشت
            </Button>
          </Box>
        </Box>
      ) : (
        <ProgressCom></ProgressCom>
      )}
    </Detail>
  );
}
